<template>
  <!-- Protocolo em formato de card para celular (as tabelas tinham 1400–2000px de largura) -->
  <div class="protocolo-card">
    <div class="protocolo-card__topo">
      <slot name="selecao" />
      <div class="protocolo-card__devedor">
        <div class="protocolo-card__nome">{{ (item.cliente && item.cliente.name) || '—' }}</div>
        <div class="protocolo-card__doc">{{ formatarCpfCnpj(item.cliente && item.cliente.cpf_cnpj) }}</div>
      </div>
      <v-chip
        small
        label
        class="protocolo-card__status"
        :color="coresStatus(item.status)"
        :dark="coresStatus(item.status) !== '#FFD400'"
      >
        {{ item.nome }}
      </v-chip>
    </div>

    <div class="protocolo-card__valor">{{ converterDinherio(item.valor_vencido) }}</div>

    <dl class="protocolo-card__dados">
      <div><dt>Vencimento</dt><dd>{{ converterDataTimestamp(item.data_vencimento) }}</dd></div>
      <div><dt>Nº Título</dt><dd>{{ item.numero_titulo || '—' }}</dd></div>
      <div><dt>Lote</dt><dd>{{ item.lote || '—' }}</dd></div>
      <div class="protocolo-card__protocolo"><dt>Protocolo</dt><dd>{{ item.protocolo }}</dd></div>
    </dl>

    <div class="protocolo-card__acoes">
      <slot name="acoes" />
    </div>
  </div>
</template>

<script>
import helper from '../mixins/helper'

export default {
  name: 'ProtocoloCard',
  mixins: [helper],
  props: {
    item: { type: Object, required: true },
  },
}
</script>

<style scoped>
.protocolo-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 14px 8px;
  margin-bottom: 10px;
  background: #fff;
  font-family: 'Inter', sans-serif;
}
.protocolo-card__topo {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.protocolo-card__devedor {
  flex: 1;
  min-width: 0;
}
.protocolo-card__nome {
  font-size: 0.92rem;
  font-weight: 700;
  color: #1e293b;
  overflow-wrap: anywhere;
}
.protocolo-card__doc {
  font-size: 0.78rem;
  color: #64748b;
}
.protocolo-card__status {
  flex-shrink: 0;
  font-size: 0.7rem !important;
  font-weight: 600;
}
.protocolo-card__valor {
  margin: 10px 0 6px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #0052a0;
}
.protocolo-card__dados {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
  margin: 0;
}
.protocolo-card__dados dt {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #94a3b8;
}
.protocolo-card__dados dd {
  margin: 0;
  font-size: 0.82rem;
  color: #1e293b;
  overflow-wrap: anywhere;
}
.protocolo-card__protocolo {
  grid-column: 1 / -1;
}
.protocolo-card__protocolo dd {
  font-size: 0.75rem;
  color: #64748b;
}
.protocolo-card__acoes {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
  margin-top: 6px;
  border-top: 1px solid #f1f5f9;
  padding-top: 4px;
}
</style>
